import axios from 'axios';
import { array, bool, object, string } from 'yup';

import { apiConfig } from '@constants';

const userProductsSchema = object({
  success: bool(),
  products: object({
    svod: array(object({})),
    tvod: array(object({})),
  }),
  paymentInfo: object({
    first_name: string(),
    last_name: string(),
  }),
});

export const getUserProducts = async headers => {
  const { data } = await axios.get(apiConfig.DSP_USER_PRODUCT_URL, { headers });

  return userProductsSchema.validate(data);
};

export const hasValidProducts = products => {
  const { svod = [], tvod = [] } = products ?? {};

  return [...svod, ...tvod].some(({ state }) => state === 'active' || state === 'trialing');
};
